import React, { Component } from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { connect } from "react-redux";
import { Box, Card, Container, Grid, Typography } from "@material-ui/core";
import "./index.css";
import { latinToPersian } from "../../components/UI/react-persian/PersianNumber";
import ChequeList from "../../components/Cheque/List/ChequeList";
import PersonList from "../../components/Person/List/PersonList";

class IndexPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      boxItems: [
        {
          title: "تعداد چک ها",
          subTitle: "تعداد چک های فعال موجود",
          color: "red",
          val: "100+",
        },
        {
          title: "تعداد چک ها",
          subTitle: "تعداد چک های فعال موجود",
          color: "green",
          val: "100+",
        },
        {
          title: "تعداد چک ها",
          subTitle: "تعداد چک های فعال موجود",
          color: "blue",
          val: "100+",
        },
        {
          title: "تعداد چک ها",
          subTitle: "تعداد چک های فعال موجود",
          color: "brown",
          val: "100+",
        },
      ],
    };
  }

  componentDidMount() {}

  createBox(item) {
    return (
      <Grid item md={3} xs={12}>
        <Box p={1}>
          <Card>
            <Box p={2} display={"flex"}>
              <Box>
                <Box
                  ml={1}
                  mr={1}
                  display={"flex"}
                  style={{
                    width: "70px",
                    height: "70px",
                    backgroundColor: item.color,
                    color: "white",
                    borderRadius: "10px",
                  }}
                  color={"primary.main"}
                  alignItems="center"
                >
                  <Box justifyContent="center" alignItems="center" m={"auto"}>
                    <Typography align={"center"} variant={"h5"}>
                      {latinToPersian(item.val)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box style={{ textAlign: "right" }} mr={1}>
                {item.title}
                <br />
                <Typography variant={"caption"}>{item.subTitle}</Typography>
              </Box>
            </Box>
          </Card>
        </Box>
      </Grid>
    );
  }

  render() {
    return (
      <Wrapper>
        <Container>
          {/*<Grid container={true}>*/}
          {/*    {this.state.boxItems.map(item => this.createBox(item))}*/}
          {/*</Grid>*/}

          <Box pb={2}>
            <Grid container={true}>
              <Grid item={true} xs={12}>
                <ChequeList
                  name={"ی بلاتکلیف"}
                  type={"not-status"}
                  perPage={5}
                />
              </Grid>
            </Grid>
          </Box>

          <Grid container={true}>
            <Grid item={true} xs={12}>
              <ChequeList name={"ی سر رسید امروز"} type={"today"} perPage={5} />
            </Grid>
          </Grid>
          <Box pt={2} pb={2}>
            <Grid container={true}>
              <Grid item={true} xs={12}>
                <ChequeList name={"ی این هفته "} type={"week-my"} perPage={5} />
              </Grid>
            </Grid>
          </Box>
          {/*<Grid container={true}>*/}
          {/*    <Grid item={true} xs={12}>*/}
          {/*        <ChequeList*/}
          {/*            name={"ی دیگران"}*/}
          {/*            type={'week-other'}*/}
          {/*            perPage={5}*/}

          {/*        />*/}
          {/*    </Grid>*/}
          {/*</Grid>*/}
          <Box pt={2}>
            <Grid container={true}>
              <Grid item={true} xs={12}>
                <ChequeList
                  name={"ی  برگشتی"}
                  type={"week-bounced"}
                  perPage={5}
                />
              </Grid>
            </Grid>
          </Box>

          <Box pt={2}>
            <Grid container={true}>
              <Grid item={true} xs={12}>
                <PersonList
                  name={"با بیشترین مانده"}
                  type={"remained-desc"}
                  perPage={5}
                  defaultSort={"remained"}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    full: state,
    loading: state.auth.loading,
    error: state.auth.error,
    tokenData: state.auth.token,
    isAuthenticated: state.auth.token !== null,
  };
};

export default connect(mapStateToProps)(IndexPage);
